export default "__VITE_ASSET__44f50b27__"